/**
 * @generated SignedSource<<c921a2afa8830ffd31b2d4ddf31b9921>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
import { UsernameOrID } from "@/common/relayCustomScalar";
export type DatasetVersionAuthorInput = {
  registered: UsernameOrID;
  unregistered?: never;
} | {
  registered?: never;
  unregistered: UnregisteredDatasetVersionAuthorInput;
};
export type UnregisteredDatasetVersionAuthorInput = {
  fullName: string;
};
export type DatasetVersionEditSheetMutation$variables = {
  authors?: ReadonlyArray<DatasetVersionAuthorInput> | null | undefined;
  datasetId: string;
  datasetVersionId: string;
  license?: string | null | undefined;
  shortDescription?: string | null | undefined;
  tags?: ReadonlyArray<string> | null | undefined;
};
export type DatasetVersionEditSheetMutation$data = {
  readonly updateDataset: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"taggableFragment">;
  };
  readonly updateDatasetVersion: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"DatasetVersionAsideContentFragment" | "DatasetVersionEditSheet" | "datasetVersionAuthorsFragment">;
  };
};
export type DatasetVersionEditSheetMutation = {
  response: DatasetVersionEditSheetMutation$data;
  variables: DatasetVersionEditSheetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "authors"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "datasetId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "datasetVersionId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "license"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shortDescription"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tags"
},
v6 = [
  {
    "kind": "Variable",
    "name": "datasetId",
    "variableName": "datasetId"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "shortDescription",
        "variableName": "shortDescription"
      },
      {
        "kind": "Variable",
        "name": "tags",
        "variableName": "tags"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = [
  {
    "kind": "Variable",
    "name": "datasetVersionId",
    "variableName": "datasetVersionId"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "authors",
        "variableName": "authors"
      },
      {
        "kind": "Variable",
        "name": "license",
        "variableName": "license"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v9 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v12/*:: as any*/)
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v15 = [
  (v7/*:: as any*/),
  (v14/*:: as any*/)
],
v16 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v12/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageThumbnail",
  "storageKey": null
},
v24 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    }
  ],
  "type": "UnregisteredUser",
  "abstractKey": null
},
v25 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*:: as any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DatasetVersionEditSheetMutation",
    "selections": [
      {
        "alias": null,
        "args": (v6/*:: as any*/),
        "concreteType": "Dataset",
        "kind": "LinkedField",
        "name": "updateDataset",
        "plural": false,
        "selections": [
          (v7/*:: as any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "taggableFragment"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v8/*:: as any*/),
        "concreteType": "DatasetVersion",
        "kind": "LinkedField",
        "name": "updateDatasetVersion",
        "plural": false,
        "selections": [
          (v7/*:: as any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DatasetVersionEditSheet"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DatasetVersionAsideContentFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "datasetVersionAuthorsFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      (v3/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "DatasetVersionEditSheetMutation",
    "selections": [
      {
        "alias": null,
        "args": (v6/*:: as any*/),
        "concreteType": "Dataset",
        "kind": "LinkedField",
        "name": "updateDataset",
        "plural": false,
        "selections": [
          (v7/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "tagList",
                "args": (v9/*:: as any*/),
                "concreteType": "TaggableConnection",
                "kind": "LinkedField",
                "name": "tags",
                "plural": false,
                "selections": [
                  (v10/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TagEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Tag",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v11/*:: as any*/),
                          (v7/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v13/*:: as any*/)
                ],
                "storageKey": "tags(first:5)"
              }
            ],
            "type": "Taggable",
            "abstractKey": "__isTaggable"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v8/*:: as any*/),
        "concreteType": "DatasetVersion",
        "kind": "LinkedField",
        "name": "updateDatasetVersion",
        "plural": false,
        "selections": [
          (v7/*:: as any*/),
          (v14/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Dataset",
            "kind": "LinkedField",
            "name": "dataset",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              },
              (v7/*:: as any*/),
              (v11/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shortDescription",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "private",
                "storageKey": null
              },
              {
                "alias": "viewerCanUpdate",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "action",
                    "value": "UPDATE_DATASET"
                  }
                ],
                "kind": "ScalarField",
                "name": "viewerCan",
                "storageKey": "viewerCan(action:\"UPDATE_DATASET\")"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DatasetVersion",
                "kind": "LinkedField",
                "name": "latestVersion",
                "plural": false,
                "selections": (v15/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": "latestCreatedVersion",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  }
                ],
                "concreteType": "DatasetVersionConnection",
                "kind": "LinkedField",
                "name": "versions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DatasetVersion",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": (v15/*:: as any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": "versions(first:1)"
              },
              {
                "alias": "versionsInput",
                "args": (v16/*:: as any*/),
                "concreteType": "DatasetVersionConnection",
                "kind": "LinkedField",
                "name": "versions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DatasetVersionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DatasetVersion",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*:: as any*/),
                          (v14/*:: as any*/),
                          (v17/*:: as any*/),
                          (v18/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v19/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v20/*:: as any*/)
                ],
                "storageKey": "versions(first:20)"
              },
              {
                "alias": "versionsInput",
                "args": (v16/*:: as any*/),
                "filters": null,
                "handle": "connection",
                "key": "DatasetVersionCreateButtonFragment_versionsInput",
                "kind": "LinkedHandle",
                "name": "versions"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  (v18/*:: as any*/),
                  (v21/*:: as any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isEntity"
                  },
                  (v22/*:: as any*/),
                  (v23/*:: as any*/),
                  (v7/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "tagList",
                    "args": (v9/*:: as any*/),
                    "concreteType": "TaggableConnection",
                    "kind": "LinkedField",
                    "name": "tags",
                    "plural": false,
                    "selections": [
                      (v10/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TagEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Tag",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v7/*:: as any*/),
                              (v11/*:: as any*/),
                              (v18/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v19/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*:: as any*/)
                    ],
                    "storageKey": "tags(first:5)"
                  },
                  {
                    "alias": "tagList",
                    "args": (v9/*:: as any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "TagListFragment_tagList",
                    "kind": "LinkedHandle",
                    "name": "tags"
                  }
                ],
                "type": "Taggable",
                "abstractKey": "__isTaggable"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "license",
            "storageKey": null
          },
          (v17/*:: as any*/),
          {
            "alias": "viewerCanUpdate",
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "UPDATE_DATASET_VERSION"
              }
            ],
            "kind": "ScalarField",
            "name": "viewerCan",
            "storageKey": "viewerCan(action:\"UPDATE_DATASET_VERSION\")"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DOI",
            "kind": "LinkedField",
            "name": "doi",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "full",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "short",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "size",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publishable",
            "storageKey": null
          },
          {
            "alias": "viewerCanPublishDatasetVersion",
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "PUBLISH_DATASET_VERSION"
              }
            ],
            "kind": "ScalarField",
            "name": "viewerCan",
            "storageKey": "viewerCan(action:\"PUBLISH_DATASET_VERSION\")"
          },
          {
            "alias": "authorsPreview",
            "args": (v9/*:: as any*/),
            "concreteType": "DatasetVersionAuthorConnection",
            "kind": "LinkedField",
            "name": "authors",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DatasetVersionAuthorConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v19/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v18/*:: as any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*:: as any*/),
                          (v21/*:: as any*/),
                          (v22/*:: as any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v23/*:: as any*/)
                            ],
                            "type": "Entity",
                            "abstractKey": "__isEntity"
                          }
                        ],
                        "type": "User",
                        "abstractKey": null
                      },
                      (v24/*:: as any*/),
                      (v25/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v20/*:: as any*/)
            ],
            "storageKey": "authors(first:5)"
          },
          {
            "alias": "authorsPreview",
            "args": (v9/*:: as any*/),
            "filters": null,
            "handle": "connection",
            "key": "DatasetVersionAsideContentAuthorsFragment_authorsPreview",
            "kind": "LinkedHandle",
            "name": "authors"
          },
          {
            "alias": "authorsCount",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 0
              }
            ],
            "concreteType": "DatasetVersionAuthorConnection",
            "kind": "LinkedField",
            "name": "authors",
            "plural": false,
            "selections": [
              (v10/*:: as any*/)
            ],
            "storageKey": "authors(first:0)"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 10
              }
            ],
            "concreteType": "DatasetVersionAuthorConnection",
            "kind": "LinkedField",
            "name": "authors",
            "plural": false,
            "selections": [
              (v10/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "DatasetVersionAuthorConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v18/*:: as any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*:: as any*/),
                          (v22/*:: as any*/)
                        ],
                        "type": "User",
                        "abstractKey": null
                      },
                      (v24/*:: as any*/),
                      (v25/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v13/*:: as any*/)
            ],
            "storageKey": "authors(first:10)"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "60ae4bab95ed41ca1a1bf9f45598772d",
    "id": null,
    "metadata": {},
    "name": "DatasetVersionEditSheetMutation",
    "operationKind": "mutation",
    "text": "mutation DatasetVersionEditSheetMutation(\n  $datasetId: ID!\n  $datasetVersionId: ID!\n  $shortDescription: String\n  $tags: [String!]\n  $license: String\n  $authors: [DatasetVersionAuthorInput!]\n) {\n  updateDataset(datasetId: $datasetId, input: {shortDescription: $shortDescription, tags: $tags}) {\n    id\n    ...taggableFragment\n  }\n  updateDatasetVersion(datasetVersionId: $datasetVersionId, input: {license: $license, authors: $authors}) {\n    id\n    ...DatasetVersionEditSheet\n    ...DatasetVersionAsideContentFragment\n    ...datasetVersionAuthorsFragment\n  }\n}\n\nfragment DatasetDOIFragment on DatasetVersion {\n  id\n  doi {\n    full\n    short\n    url\n  }\n}\n\nfragment DatasetVersionAsideContentAuthorsFragment on DatasetVersion {\n  authorsPreview: authors(first: 5) {\n    edges {\n      cursor\n      node {\n        __typename\n        ... on User {\n          id\n          username\n          displayName\n          ...EntityProfilePicFragment_49kWkb\n        }\n        ... on UnregisteredUser {\n          fullName\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment DatasetVersionAsideContentFragment on DatasetVersion {\n  id\n  version\n  license\n  publishedAt\n  viewerCanUpdate: viewerCan(action: UPDATE_DATASET_VERSION)\n  doi {\n    full\n  }\n  dataset {\n    id\n    slug\n    name\n    shortDescription\n    private\n    viewerCanUpdate: viewerCan(action: UPDATE_DATASET)\n    ...TagListFragment\n    ...DatasetVersionCreateButtonFragment\n  }\n  ...DatasetVersionCardFragment\n  ...DatasetVersionEditSheet\n  ...DatasetVersionAsideContentAuthorsFragment\n  ...DatasetDOIFragment\n  authorsCount: authors(first: 0) {\n    totalCount\n  }\n}\n\nfragment DatasetVersionCardFragment on DatasetVersion {\n  id\n  version\n  size\n  publishedAt\n  createdAt\n  updatedAt\n  dataset {\n    id\n    slug\n    owner {\n      __typename\n      username\n      ...EntityProfilePicFragment_49kWkb\n      id\n    }\n  }\n  ...DatasetVersionPublishButtonFragment\n}\n\nfragment DatasetVersionCreateButtonFragment on Dataset {\n  id\n  latestVersion {\n    id\n    version\n  }\n  latestCreatedVersion: versions(first: 1) {\n    nodes {\n      id\n      version\n    }\n  }\n  versionsInput: versions(first: 20) {\n    edges {\n      node {\n        id\n        version\n        publishedAt\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment DatasetVersionEditSheet on DatasetVersion {\n  id\n  version\n  dataset {\n    slug\n    id\n  }\n}\n\nfragment DatasetVersionPublishButtonFragment on DatasetVersion {\n  id\n  version\n  publishable @ifAllowed\n  viewerCanPublishDatasetVersion: viewerCan(action: PUBLISH_DATASET_VERSION)\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n\nfragment TagFragment on Tag {\n  name\n}\n\nfragment TagListFragment on Taggable {\n  __isTaggable: __typename\n  tagList: tags(first: 5) {\n    totalCount\n    edges {\n      node {\n        id\n        ...TagFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment datasetVersionAuthorsFragment on DatasetVersion {\n  authors(first: 10) {\n    totalCount\n    edges {\n      node {\n        __typename\n        ... on User {\n          id\n          displayName\n        }\n        ... on UnregisteredUser {\n          fullName\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n    pageInfo {\n      endCursor\n    }\n  }\n  id\n}\n\nfragment taggableFragment on Taggable {\n  __isTaggable: __typename\n  tagList: tags(first: 5) {\n    totalCount\n    edges {\n      node {\n        name\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "457fc3c9350846e0b6e1cbae7f9d1bae";

export default node;
